import { z } from 'zod';

import { PropertyId } from '../BrandedIds';
import {
  InspectionGeneralCondition,
  InspectionInsurableDamages,
  InspectionOccupancyStatus,
  InspectionOccupancyType,
  InspectionType,
} from '../loan/Inspection';
import { zodDateOrString } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

export const AddInspectionEvent = BaseLoanEvent.extend({
  type: z.literal('addInspection'),
  propertyId: PropertyId,
  date: zodDateOrString,
  repairEstimate: z.number().nonnegative().optional(),
  inspectionType: InspectionType,
  occupancyStatus: InspectionOccupancyStatus,
  occupancyType: InspectionOccupancyType,
  interiorAccessGranted: z.boolean(),
  generalCondition: InspectionGeneralCondition,
  insurableDamages: InspectionInsurableDamages,
  condemnedFlag: z.boolean().optional(),
  orderId: z.string().optional(),
});

export type AddInspectionEvent = z.infer<typeof AddInspectionEvent>;
